<template>
  <div v-if="challenge.finished_at || challenge.count_unfinished_retries > 0">
    <p class="font-weight-bold mb-0">
      Desafio - {{ challenge.count_questions }} questões
    </p>
    <p class="mb-0">
      {{ challenge.minutes }} minutos
    </p>
    <p
      v-if="challenge.finished_before_reopened && !challenge.is_running"
      class="mb-0"
    >
      {{ challenge.count_correct }} de {{ challenge.count_questions }} acertadas.
    </p>
    <p
      v-if="!cycle.show_result && challenge.count_unfinished_retries == 0"
      class="mb-0 font-weight-bolder mt-1"
    >
      Aguardando o resultado completo.
    </p>
    <CardTimeCounter 
      v-if="challenge.is_running"
      :challenge="challenge"
    />
  </div>
  <div v-else>
    <p class="font-weight-bold mb-0">
      Desafio {{ challenge.count_questions }} questões
    </p>
    <p class="mb-0">
      {{ challenge.minutes }} minutos
    </p>
    <CardApplicationDates
      v-if="!challenge.is_running"
      :begin="cycle.begin_challenge_apply"
      :end="cycle.end_challenge_apply"
    />
    <CardTimeCounter 
      v-if="challenge.is_running"
      :challenge="challenge"
    />
  </div>
</template>
<script>
import CardApplicationDates from '@/student/components/CardApplicationDates'
import CardTimeCounter from "./CardTimeCounter";

export default {
  components: { CardApplicationDates, CardTimeCounter },
  props: {
    challenge: {
      type: Object,
      required: true,
    },
    cycle: {
      type: Object,
      required: true
    },
  },
}
</script>
